import {
  handlePANFieldValidations,
  prefillDetailsByEmail,
} from "../bidderFormServices/getDetails";

interface PartnershipBidderFormFieldConfig {
  id: string;
  fieldLabel: string;
  value: string;
  onChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => void;
  formFieldErrors: string;
  formFieldType: string;
  hideConditions: boolean;
  disableConditions: boolean;
  showVerifiedIcon?: boolean;
  isVerified?: boolean;
  inputFieldClass?: string;
  disablePan?: boolean;
  setDisablePan?: any;
  setNotificationPopup?: any;
  // V4 name-first flow: debounced callback to trigger PAN verification
  debouncedNameChange?: () => void;
}
const getPartnershipFormFieldsConfig = (
  form: any,
  mode: any,
  setIsFetchingPan: any,
  setIsNameVerified: any,
  isNameVerified: boolean,
  disablePan: boolean,
  setDisablePan: any,
  setNotificationPopup: any,
  debouncedNameChange?: () => void,
): PartnershipBidderFormFieldConfig[] => {
  return [
    {
      id: "email",
      fieldLabel: "Email",
      value: form.getField("email") ?? "",
      onChange: (e: any) =>
        prefillDetailsByEmail(
          e,
          form,
          disablePan,
          setDisablePan,
          setIsNameVerified,
          "partnership",
          setNotificationPopup,
        ),
      formFieldErrors: form.errors.get("email")
        ? form.errors.get("email")[0]
        : "",
      formFieldType: "input",
      hideConditions: false,
      disableConditions: mode === "view" || mode === "edit",
    },
    {
      id: "name",
      fieldLabel: "Name",
      value: form.getField("name") ?? "",
      onChange: (e: any) => {
        const newName = e.target.value?.toUpperCase();
        form.setField("name", newName);
        // V4 name-first flow: trigger PAN verification after name >= 3 chars
        if (debouncedNameChange) {
          debouncedNameChange();
        }
      },
      formFieldErrors: form.errors.get("name")
        ? form.errors.get("name")[0]
        : "",
      formFieldType: "input",
      hideConditions: false,
      disableConditions: mode === "view",
    },
    {
      id: "pan",
      fieldLabel: "Pan no.",
      value: form.getField("pan") ?? "",
      onChange: (e: any) =>
        handlePANFieldValidations(e, form, setIsFetchingPan, setIsNameVerified),
      formFieldErrors: form.errors.get("pan") ? form.errors.get("pan")[0] : "",
      formFieldType: "input",
      hideConditions: false,
      disableConditions: mode === "view" || mode === "edit" || disablePan,
      showVerifiedIcon: true,
      isVerified: isNameVerified,
    },
    {
      id: "aadhar_number",
      fieldLabel: "Aadhar Number",
      value: form.getField("aadhar_number") ?? "",
      onChange: (e: any) => form.setField("aadhar_number", e.target.value),
      formFieldErrors: form.errors.get("aadhar_number")
        ? form.errors.get("aadhar_number")[0]
        : "",
      formFieldType: "input",
      hideConditions: false,
      disableConditions: mode === "view",
    },
    {
      id: "mobile_number",
      fieldLabel: "Mobile no.",
      value: form.getField("mobile_number") ?? "",
      onChange: (e: any) => form.setField("mobile_number", e.target.value),
      formFieldErrors: form.errors.get("mobile_number")
        ? form.errors.get("mobile_number")[0]
        : "",
      formFieldType: "input",
      hideConditions: false,
      disableConditions: mode === "view" || mode === "edit",
    },
    {
      id: "address",
      fieldLabel: "Address",
      value: form.getField("address") ?? "",
      onChange: (e: any) => form.setField("address", e.target.value),
      formFieldErrors: form.errors.get("address")
        ? form.errors.get("address")[0]
        : "",
      formFieldType: "input",
      hideConditions: false,
      disableConditions: mode === "view",
    },
  ];
};

export { getPartnershipFormFieldsConfig };
